import { Attachment } from 'src/careflow/ph-core/fhir-client/resources';

export const imageFromAttachment = (attachment?: Attachment) =>
  `data:${attachment?.contentType};base64,${attachment?.data}`;
